export default {
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_LABEL: 'ŒIL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL: 'POWER',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL: 'DIA',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL: 'BC',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL: 'ADD',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL: 'BOÎTES',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL: 'AXIS',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL: 'CYL',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL: 'COLOR',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LONG_LABEL:
        'OD (œil droit)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LONG_LABEL:
        'OS (œil gauche)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_RIGHT_LABEL: 'OD (droit)',
    MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_EYE_TYPE_LEFT_LABEL: 'OS (gauche)',
    SAME_PRESCRIPTION_BOTH_EYES: 'Même ordonnance pour les deux yeux',
    ADD_PRESCRIPTION_STEP_1_LEFT: 'OS (œil gauche)',
    CONTACT_LENSES_SHOW_SAVED_PRESCRIPTION: "afficher l'ordonnance",
    CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED:
        'Don’t forget to save this prescription at checkout for future speedier shopping!',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1: 'Insert your prescription values below or',
    CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2: 'to select one of your saved prescriptions.',
    CONTACT_LENSES_PRESCRIPTION_INCLUDE_PRODUCT_IN_PURCHASE_CHECKBOX:
        'Include this product in my purchase',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPLOAD: 'Téléchargé sur',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_UPDATE: 'LDernière mise à jour: ',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_JUST_UPDATED: 'Juste mis à jour',
    MYPROFILE_MY_PRESCRIPTIONS_TILE_TODAY: "Aujourd'hui",
    MYPROFILE_MY_PRESCRIPTIONS_TILE_YESTERDAY: 'Hier',
    SIGN_IN: 'Ouvrez une session',
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT1:
        "You don't have a prescription saved in your account including this product.",
    MYPROFILE_NO_PRESCRIPTION_SAVED_PT2:
        'Ajoutez votre ordonnance ci-dessous et sauvegardez-la pour des achats futurs',
    CL_PDP_TITLE: "Sélectionnez votre type d'ordonnance",
    CL_PDP_ERROR:
        'Veuillez sélectionner votre ordonnance pour ajouter les verres de contact à votre panier et décochez la case si un seul œil est nécessaire.',
    CL_PDP_PRESCRIPTION_NOT_AVAIABLE: "L'ordonnance sélectionnée n'est pas offerte",
    YOUR_PRESCRIPTION_TITLE: 'Votre ordonnance',
    YOUR_PRESCRIPTION_SUBTITLE_PT1:
        'Nous utiliserons cette information pour nous assurer que l’intégralité de votre commande est correcte.',
    YOUR_PRESCRIPTION_SUBTITLE_PT2: 'Nous sommes là pour vous.',
    YOUR_DOCTOR_DETAILS: 'Les détails de votre optométriste',
    DOCTOR_NAME: "nom de l'optométriste",
    CLINIC_NAME: 'Nom de la clinique',
    ADDRESS: 'Adresse',
    SUBMISSION_METHOD: 'Votre méthode de soumission',
    MY_SAVED_PRESCRIPTION_TITLE_LABEL: 'My saved prescriptions',
    MY_SAVED_PRESCRIPTION_PRESCRIPTION_NAME_LABEL: 'Nom de l’ordonnance',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_1 : 'Économisez ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_2 : ' à l’achat d’un approvisionnement annuel de ',
    ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_3 : ' boîtes!',
};
